import { LaneOverlapping, WallDistance } from "../../../enums/configuration/navigator-settings";
import ErrorSignalization from "../cleaning-configurations/error-signalization";
import {
  CleaningConfiguration,
  CleaningConfigurationApi,
  mapCleaningConfigurationApiToCleaningConfiguration,
  mapCleaningConfigurationToApi,
} from "../cleaning-configurations/global-cleaning-configuration";
import { mapMapRulesConfigurationApiToMapRulesConfiguration, mapMapRulesConfigurationToApi, MapRulesConfiguration, MapRulesConfigurationApi } from "../cleaning-configurations/map-rules-configuration";

interface ParamList {
  homeOnDirtBinFull: boolean;
  dirtBinFullTimeH: number;
  cleaningConfiguration: CleaningConfiguration;
  mapRulesConfiguration: MapRulesConfiguration;
  filterCleanerDisabled: boolean;
  allowServiceConnectionFromCloud: boolean;
  objectNearDistanceM: number;
  idleTime: number;
  homingTimeout: number;
  minScheduleJobDuration: number;
  maxPylonGap: number;
  batteryLow: number;
  batteryCleaningStart: number;
  errorSignalisation: ErrorSignalization;
  openSpaceLaneMode: LaneOverlapping;
  openSpaceWallDistanceMode: WallDistance;
}

export interface ParamListApi {
  homeOnDirtBinFull: boolean;
  dirtBinFullTimeH: number;
  cleaningConfiguration: CleaningConfigurationApi;
  mapRulesConfiguration: MapRulesConfigurationApi;
  filterCleanerDisabled: boolean;
  allowServiceConnectionFromCloud: boolean;
  objectNearDistanceM: number;
  idleTime: number;
  homingTimeout: number;
  minScheduleJobDuration: number;
  maxPylonGap: number;
  batteryLow: number;
  batteryCleaningStart: number;
  errorSignalisation: ErrorSignalization;
  openSpaceLaneMode: LaneOverlapping;
  openSpaceWallDistanceMode: WallDistance;
}

export const mapParamListApiToParamList = (apiData: ParamListApi) =>
  ({
    ...apiData,
    cleaningConfiguration: mapCleaningConfigurationApiToCleaningConfiguration(apiData.cleaningConfiguration),
    mapRulesConfiguration: mapMapRulesConfigurationApiToMapRulesConfiguration(apiData.mapRulesConfiguration),
  } as ParamList);

export const mapPartialParamListToParamListApi = (paramList: Partial<ParamList>) =>
  ({
    ...paramList,
    cleaningConfiguration:
      paramList.cleaningConfiguration != null
        ? mapCleaningConfigurationToApi(paramList.cleaningConfiguration)
        : undefined,
    mapRulesConfiguration:
      paramList.mapRulesConfiguration != null
        ? mapMapRulesConfigurationToApi(paramList.mapRulesConfiguration)
        : undefined,
  } as Partial<ParamListApi>);

export default ParamList;
